import { css } from "@emotion/css"
import COLOR_CODE from "../../../constant/color"

type Props = {
  caption?: string
  isShow?: boolean
  children: React.ReactNode
}

export const OneClickFieldContainer = ({ caption, children, isShow = true }: Props) => {
  if (!isShow) {
    return null
  }

  return (
    <section>
      {caption && <h3 className={h3}>{caption}</h3>}
      <div className={style}>{children}</div>
    </section>
  )
}

export default OneClickFieldContainer

const h3 = css`
  height: 20px;
  padding-left: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #555e68;
  text-align: left;
  background-color: ${COLOR_CODE.BACKGROUND_GRAY};
`

const style = css`
  color: #32383e;
  > *:not(:first-child) {
    margin-top: -1px;
  }
`
